import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function BlockedUser(props: SvgIconProps) {
  return (
    <SvgIcon height="133" viewBox="0 0 160 133" width="160" {...props}>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint0_linear"
          x1="117.552"
          x2="49.172"
          y1="109.817"
          y2="24.4508"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F6FD" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint1_linear"
          x1="105.711"
          x2="80.8434"
          y1="42.8799"
          y2="67.7475"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint2_linear"
          x1="78.5218"
          x2="37.4954"
          y1="63.4969"
          y2="104.522"
        >
          <stop stopColor="#FBEFEF" />
          <stop offset="1" stopColor="#E9BABA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint3_linear"
          x1="89.1106"
          x2="71.091"
          y1="62.9171"
          y2="62.9171"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint4_linear"
          x1="85.3827"
          x2="60.1174"
          y1="43.7752"
          y2="43.7752"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint5_linear"
          x1="74.8228"
          x2="74.8228"
          y1="18.7206"
          y2="55.631"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint6_linear"
          x1="55.109"
          x2="71.1837"
          y1="137.085"
          y2="121.01"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint7_linear"
          x1="111.776"
          x2="88.7988"
          y1="136.383"
          y2="113.408"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint8_linear"
          x1="53.8599"
          x2="104.033"
          y1="78.9315"
          y2="129.106"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="blockedUser-paint9_linear"
          x1="122"
          x2="103.5"
          y1="44"
          y2="75.1875"
        >
          <stop stopColor="#FBEFEF" />
          <stop offset="1" stopColor="#E9BABA" />
        </linearGradient>
      </defs>
      <mask
        height="133"
        id="blockedUser-mask0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="160"
        x="0"
        y="0"
      >
        <path
          d="M56.4219 6.07812C44.6969 11.4031 38.3519 27.3401 32.6359 40.9381C28.8039 50.0581 25.2499 58.1281 20.5459 61.2361C-5.90806 78.7211 -2.97806 101.896 8.01094 116.356C14.4079 124.77 25.3049 132.264 37.2809 132.264C45.3989 132.264 54.0129 128.819 62.0569 119.881C82.7199 96.9251 96.6069 102.243 110.536 107.562C119.861 111.124 129.206 114.684 140.616 109.76C151.531 105.048 160.137 97.0301 159.89 82.5381C159.738 73.5001 156.14 61.9381 147.507 47.0941C139.301 32.9781 128.547 20.2521 115.921 11.6611C105.59 4.63312 94.0089 0.369117 81.5349 0.370117C73.5009 0.370117 65.0949 2.14012 56.4219 6.07812Z"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask0)">
        <path
          clipRule="evenodd"
          d="M56.4219 6.07812C44.6969 11.4031 38.3519 27.3401 32.6359 40.9381C28.8039 50.0581 25.2499 58.1281 20.5459 61.2361C-5.90806 78.7211 -2.97806 101.896 8.01094 116.356C14.4079 124.77 25.3049 132.264 37.2809 132.264C45.3989 132.264 54.0129 128.819 62.0569 119.881C82.7199 96.9251 96.6069 102.243 110.536 107.562C119.861 111.124 129.206 114.684 140.616 109.76C151.531 105.048 160.137 97.0301 159.89 82.5381C159.738 73.5001 156.14 61.9381 147.507 47.0941C139.301 32.9781 128.547 20.2521 115.921 11.6611C105.59 4.63312 94.0089 0.369117 81.5349 0.370117C73.5009 0.370117 65.0949 2.14012 56.4219 6.07812Z"
          fill="url(#blockedUser-paint0_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="36"
        id="blockedUser-mask1"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="36"
        x="75"
        y="37"
      >
        <path
          d="M75.6929 55.313C75.6929 65.025 83.5659 72.898 93.2769 72.898C102.989 72.898 110.862 65.025 110.862 55.314C110.861 45.602 102.989 37.729 93.2769 37.729C83.5659 37.729 75.6929 45.603 75.6929 55.314"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask1)">
        <path
          clipRule="evenodd"
          d="M75.6929 55.313C75.6929 65.025 83.5659 72.898 93.2769 72.898C102.989 72.898 110.862 65.025 110.862 55.314C110.861 45.602 102.989 37.729 93.2769 37.729C83.5659 37.729 75.6929 45.603 75.6929 55.314"
          fill="url(#blockedUser-paint1_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="59"
        id="blockedUser-mask2"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="59"
        x="29"
        y="55"
      >
        <path
          d="M29 84.01C29 100.031 41.988 113.019 58.009 113.019C74.031 113.019 87.018 100.031 87.018 84.009C87.018 67.989 74.031 55 58.008 55C41.989 55 29.001 67.989 29.001 84.01"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask2)">
        <path
          clipRule="evenodd"
          d="M29 84.01C29 100.031 41.988 113.019 58.009 113.019C74.031 113.019 87.018 100.031 87.018 84.009C87.018 67.989 74.031 55 58.008 55C41.989 55 29.001 67.989 29.001 84.01"
          fill="url(#blockedUser-paint2_linear)"
          fillRule="evenodd"
        />
      </g>
      <rect
        fill="#F44336"
        height="41"
        opacity="0.2"
        rx="3.5"
        transform="rotate(45 69.5208 67.5295)"
        width="7"
        x="69.5208"
        y="67.5295"
      />
      <rect
        fill="#F44336"
        height="41"
        opacity="0.2"
        rx="3.5"
        transform="rotate(-45 40.5293 72.4792)"
        width="7"
        x="40.5293"
        y="72.4792"
      />
      <mask
        height="20"
        id="blockedUser-mask3"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="19"
        x="71"
        y="53"
      >
        <path
          d="M72.9478 59.7631C72.9478 59.7631 75.2728 65.2061 71.0908 67.0671L81.6838 72.2451L89.1108 67.0671C89.1108 67.0671 83.8788 62.4191 83.0288 53.5891L72.9488 59.7631H72.9478Z"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask3)">
        <path
          clipRule="evenodd"
          d="M72.9478 59.7631C72.9478 59.7631 75.2728 65.2061 71.0908 67.0671L81.6838 72.2451L89.1108 67.0671C89.1108 67.0671 83.8788 62.4191 83.0288 53.5891L72.9488 59.7631H72.9478Z"
          fill="url(#blockedUser-paint3_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="35"
        id="blockedUser-mask4"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="26"
        x="60"
        y="26"
      >
        <path
          d="M70.106 27.3611C70.106 27.3611 63.8 28.7121 64.266 34.4441C64.75 40.3641 63.049 46.4791 61.231 47.8201C59.412 49.1601 60.369 50.5001 60.369 50.5001C60.369 50.5001 60.944 51.6421 62.762 51.4571C64.099 51.3201 63.919 52.3911 63.82 52.8081C63.242 55.2271 61.3 60.9901 67.234 60.5761C72.78 60.1891 84.177 58.1831 84.847 48.2281C85.455 39.2041 87.712 26.9541 74.653 26.9531C73.306 26.9531 71.797 27.0831 70.106 27.3611Z"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask4)">
        <path
          clipRule="evenodd"
          d="M70.106 27.3611C70.106 27.3611 63.8 28.7121 64.266 34.4441C64.75 40.3641 63.049 46.4791 61.231 47.8201C59.412 49.1601 60.369 50.5001 60.369 50.5001C60.369 50.5001 60.944 51.6421 62.762 51.4571C64.099 51.3201 63.919 52.3911 63.82 52.8081C63.242 55.2271 61.3 60.9901 67.234 60.5761C72.78 60.1891 84.177 58.1831 84.847 48.2281C85.455 39.2041 87.712 26.9541 74.653 26.9531C73.306 26.9531 71.797 27.0831 70.106 27.3611Z"
          fill="url(#blockedUser-paint4_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="38"
        id="blockedUser-mask5"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="38"
        x="56"
        y="18"
      >
        <path
          d="M56.546 25.7332C54.886 34.4132 62.289 33.1362 69.819 34.0292C77.349 34.9232 76.328 40.4112 76.328 41.3042C76.328 41.3042 76.201 42.4542 76.584 44.4952C76.966 46.5372 80.668 44.6232 82.199 43.8572C83.731 43.0912 85.389 45.2612 83.348 47.5582C81.306 49.8562 79.646 50.2382 83.22 54.7052C86.794 59.1722 91.005 46.5372 92.92 36.8372C94.834 27.1372 89.729 25.9882 85.773 26.2442C81.816 26.4992 83.22 26.8822 77.221 22.0322C74.626 19.9342 70.718 18.7202 66.984 18.7202C62.086 18.7192 57.486 20.8092 56.545 25.7332"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask5)">
        <path
          clipRule="evenodd"
          d="M56.546 25.7332C54.886 34.4132 62.289 33.1362 69.819 34.0292C77.349 34.9232 76.328 40.4112 76.328 41.3042C76.328 41.3042 76.201 42.4542 76.584 44.4952C76.966 46.5372 80.668 44.6232 82.199 43.8572C83.731 43.0912 85.389 45.2612 83.348 47.5582C81.306 49.8562 79.646 50.2382 83.22 54.7052C86.794 59.1722 91.005 46.5372 92.92 36.8372C94.834 27.1372 89.729 25.9882 85.773 26.2442C81.816 26.4992 83.22 26.8822 77.221 22.0322C74.626 19.9342 70.718 18.7202 66.984 18.7202C62.086 18.7192 57.486 20.8092 56.545 25.7332"
          fill="url(#blockedUser-paint5_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="35"
        id="blockedUser-mask6"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="10"
        x="51"
        y="94"
      >
        <path
          d="M51.8849 117.672C51.7539 121.26 51.6329 124.922 51.5959 128.447C54.0419 127.084 56.4759 125.323 58.8739 123.113C59.8039 111.948 60.9009 97.2031 60.9009 97.2031L51.8849 94.3401C51.8849 94.3401 52.3249 105.708 51.8849 117.672Z"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask6)">
        <path
          clipRule="evenodd"
          d="M51.8849 117.672C51.7539 121.26 51.6329 124.922 51.5959 128.447C54.0419 127.084 56.4759 125.323 58.8739 123.113C59.8039 111.948 60.9009 97.2031 60.9009 97.2031L51.8849 94.3401C51.8849 94.3401 52.3249 105.708 51.8849 117.672Z"
          fill="url(#blockedUser-paint6_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="13"
        id="blockedUser-mask7"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="10"
        x="98"
        y="94"
      >
        <path
          d="M98.72 97.2031L99.372 103.867C102.144 104.511 104.849 105.433 107.539 106.43C107.537 99.4531 107.735 94.3401 107.735 94.3401L98.719 97.2031H98.72Z"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask7)">
        <path
          clipRule="evenodd"
          d="M98.72 97.2031L99.372 103.867C102.144 104.511 104.849 105.433 107.539 106.43C107.537 99.4531 107.735 94.3401 107.735 94.3401L98.719 97.2031H98.72Z"
          fill="url(#blockedUser-paint7_linear)"
          fillRule="evenodd"
        />
      </g>
      <mask
        height="59"
        id="blockedUser-mask8"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width="61"
        x="49"
        y="65"
      >
        <path
          d="M80.1 69.094C74.729 69.161 71.09 67.067 71.09 67.067C63.851 69.211 58.688 70.617 55.642 76.652C51.991 83.885 49.417 93.886 49.417 93.886L60.089 97.332L58.513 123.441C59.755 122.317 60.9376 121.13 62.056 119.883C77.54 102.679 89.22 101.353 99.962 104.008L99.422 97.158L109.652 93.856C109.652 93.856 107.964 83.857 104.559 76.652C101.67 70.54 95.325 68.122 88.085 65.979C88.085 65.979 85.471 69.161 80.099 69.094"
          fill="white"
        />
      </mask>
      <g mask="url(#blockedUser-mask8)">
        <path
          clipRule="evenodd"
          d="M80.1 69.094C74.729 69.161 71.09 67.067 71.09 67.067C63.851 69.211 58.688 70.617 55.642 76.652C51.991 83.885 49.417 93.886 49.417 93.886L60.089 97.332L58.513 123.441C59.755 122.317 60.9376 121.13 62.056 119.883C77.54 102.679 89.22 101.353 99.962 104.008L99.422 97.158L109.652 93.856C109.652 93.856 107.964 83.857 104.559 76.652C101.67 70.54 95.325 68.122 88.085 65.979C88.085 65.979 85.471 69.161 80.099 69.094"
          fill="url(#blockedUser-paint8_linear)"
          fillRule="evenodd"
        />
      </g>
      <rect fill="#F44336" height="26" width="26" x="90" y="42" />
      <path
        clipRule="evenodd"
        d="M103.5 35.8125C92.6269 35.8125 83.8125 44.6269 83.8125 55.5C83.8125 66.3731 92.6269 75.1875 103.5 75.1875C114.373 75.1875 123.188 66.3731 123.188 55.5C123.188 44.6269 114.373 35.8125 103.5 35.8125ZM103.5 44.25C101.947 44.25 100.688 45.5092 100.688 47.0625V55.5C100.688 57.0533 101.947 58.3125 103.5 58.3125C105.053 58.3125 106.312 57.0533 106.312 55.5V47.0625C106.312 45.5092 105.053 44.25 103.5 44.25ZM103.5 61.125C101.947 61.125 100.688 62.3842 100.688 63.9375C100.688 65.4908 101.947 66.75 103.5 66.75C105.053 66.75 106.312 65.4908 106.312 63.9375C106.312 62.3842 105.053 61.125 103.5 61.125Z"
        fill="url(#blockedUser-paint9_linear)"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default BlockedUser
